<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="检测项" :isSearch="true" @search="search"  @emptySearch="emptySearch" :searchKey="searchKey" keyName="chineseName">
      <router-link to="/detection-new" slot="before-left"><el-button type="primary">新建检测项</el-button></router-link>
    </pt-page-title>
    <!-- 筛选 -->
    <pt-page-factor-filter :labels="filterLabels" v-model="filterForm" isQueryRouter ref="filter" @Filter="handleFilter">
      <div>
          <el-button type="primary" @click="handleFilter(false)">筛选</el-button>
      </div>
    </pt-page-factor-filter>
    <!-- 表格 -->
    <pt-detection-table :category="currentCategoryFilter" :paramsData="paramsData" ref="table" :isFromRouter="isFromRouter">
      <template slot-scope="scope">
        <i class="iconfont icon-xiangqing pointer" @click="goDetail(scope.row.id, scope.row)"></i>
        <i class="iconfont icon-bianji pointer" @click="goEdit(scope.row.id,scope.row)"></i>
        <i :class="['iconfont','icon-shanchu',scope.row.engineDefault ? 'disabled' : 'pointer']" @click="!scope.row.engineDefault && goDelete(scope.row.id,scope.row)"></i>
      </template>
    </pt-detection-table>
  </div>
</template>

<script>
import ptDetectionTable from './pt-detection-table/withData'
import { filterFactor } from './detection-list-options.js'
// 组件class前缀
const prefixCls = 'pt-detection-list'

export default {
  name: 'pt-detection-list',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptDetectionTable
  },
  data () {
    return {
      filterLabels: filterFactor,
      filterForm: {},
      currentCategoryFilter: '',
      loading: false,
      isFromRouter: false,
      searchKey: '',
      paramsData: {}
    }
  },
  methods: {
    handleFilter (isFromRouter) {
      if (!isFromRouter) {
        this.searchKey = null
        if (this.filterForm.chineseName) {
          this.$delete(this.filterForm, 'chineseName')
        }
      }
      this.paramsData = { ...this.filterForm }
      this.isFromRouter = isFromRouter
      // 筛选时不考虑关键字的问题
      if (!this.filterForm.category) {
        this.filterForm.category = null
      }
      this.$nextTick(_ => {
        if (!this.isFromRouter) {
          this.$refs.filter.getAddRouter(this.filterForm)
        }
      })
    },
    search (key) {
      this.searchKey = key
      this.$set(this.paramsData, 'chineseName', key)
      if (this.filterForm.category) {
        this.$delete(this.filterForm, 'category')
        this.$delete(this.paramsData, 'category')
      }
    },
    emptySearch () {
      this.$delete(this.paramsData, 'chineseName')
    },
    goDetail (id, data) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'detection-detail', params: { id: id, value: data } })
    },
    goEdit (id, data) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'detection-update', params: { id: id, category: data.category } })
    },
    goDelete (id, data) {
      this.$confirm('是否要删除检测项“' + data.chineseName + '”?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deleteDetection', id).then(res => {
          this.loading = false
          this.$refs.table.reload()
          this.$message.success('成功删除了检测项' + data.chineseName + '!')
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error('删除失败!')
        })
      })
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
